<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">提现管理</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <el-form :inline="true" :model="query">
                <el-form-item label="提现用户姓名：">
                    <el-input clearable type="text" v-model="query.realname"></el-input>
                </el-form-item>
                <el-form-item label="提现卡号：">
                    <el-input clearable type="text" v-model="query.code"></el-input>
                </el-form-item>
                <el-form-item label="提现时间：">
                    <el-date-picker @change="dateRangeChangFun"
                                    v-model="dateRange"
                                    type="daterange"
                                    align="right"
                                    value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="状态：">
                    <el-select clearable v-model="query.type">
                        <el-option v-for="item in cashType" :key="item.name" :label="item.label" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态：">
                    <el-select clearable v-model="query.status">
                        <el-option v-for="item in statuses" :key="item.name" :label="item.label" :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>

        <hr/>
        <div class="title">
            <span>提现列表</span>
        </div>
        <el-button type="primary" size="small" @click="batchControlAuthentication('SUCCESS')">批量审核通过</el-button>
        <el-button type="primary" size="small" @click="batchControlAuthentication('REJECT')">批量审核拒绝</el-button>
        <el-button type="primary" size="small" @click="exportWithdrawalsRecord">导出</el-button>
        <div class="content-data" v-if="cashItems && 0 < cashItems.length">
            <el-table :data="cashItems" highlight-current-row border ref="multipleTable"
                      @selection-change="handleSelectionChange">
                <el-table-column label="序号" type="selection"/>
                <el-table-column label="时间" prop="createTime"/>
                <el-table-column label="提现类型" prop="typeLabel"/>
                <el-table-column label="提现用户" prop="nickname"/>
                <el-table-column label="提现金额" prop="money"/>
                <el-table-column label="提现积分">
                    <template slot-scope="scope">
                        <div>{{scope.row.integral || 0}}</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="手续费" prop="serviceFee"/> -->
                <!-- <el-table-column label="到账金额">
                    <template slot-scope="scope">
                        <span>{{scope.row.money-scope.row.serviceFee}}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="银行" prop="bankName"/>
                <el-table-column label="卡号" prop="code"/>
                <el-table-column label="持卡人" prop="bankUserName"/>
                <el-table-column label="状态" prop="statusLabel"/>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <p>
                            <el-button type="primary" size="mini" round @click="openCheckDialog(scope.row.id)"
                                       v-if="scope.row.status == 'APPLY'">审核
                            </el-button>
                        </p>
                        <p>
                            <!-- <el-button type="primary" size="mini" round
                                       @click="$common.goRouterLink({ name: 'cashDetail',query: { cashId: scope.row.id } })">
                                详情
                            </el-button> -->
                        </p>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="withdrawalsRecord/pageWithdrawalsRecord" v-bind:query="query"
                   ref="pager" v-bind:init="true"></vue-pager>

        <div class="content-modal">
            <el-dialog title="提现审核" :visible.sync="dialogVisible" width="60%" center>
                <el-form ref="formName" :model="checkModel" :rules="rules" label-width="100px"
                         style="width:80%;margin:0 auto;">
                    <el-form-item label="审核结果：" prop="status">
                        <el-select clearable v-model="checkModel.status">
                            <el-option v-for="item in checkStauses" :key="item.name" :label="item.label"
                                       :value="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审核说明：">
                        <el-input type="textarea" :rows="2" v-model="checkModel.remark" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" :disabled="disabledCash" type="primary" @click="updateBalanceExtractStatus('formName')">提交
                        </el-button>
                        <el-button size="small" @click="resetForm('formName')">重置</el-button>
                        <el-button size="small" @click="dialogVisible=false">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                cashItems: [],
                query: {},
                dateRange: '',
                statuses: [],
                cashType: [],
                statusMap: {},
                userInfo: '',
                dialogVisible: false,
                checkModel: {
                    withdrawIds: [],
                    status: 'SUCCESS',
                },
                extractId: '',
                disabledCash: false,
                dynamicResourcePath: config.dynamicResourcePath,
                menus: null,
                checkInputs: [],
                checkStauses: [{label: '通过', name: 'SUCCESS'}, {label: '拒绝', name: 'REJECT'}],
                rules: {
                    status: [{required: true, message: "请选择审核状态", trigger: "blur"}],
                }
            }
        },
        created() {
            var _this = this;
            _this.menus = _this.$common.cache("menus");
            _this.userInfo = _this.$common.cache('user_info');
            _this.statuses = _this.$common.enum_config('EWithdrawStatus');
            if (_this.statuses) {
                _this.statuses.splice(0, 0, {name: '', label: '全部'});
            }
            _this.cashType = _this.$common.enum_config('EWithdrawalsRecordType');
            if (_this.cashType) {
                _this.cashType.splice(0, 0, {name: '', label: '全部'});
            }
            _this.statuses.forEach((item) => {
                _this.statusMap[item.name] = item.label;
            });
        },
        methods: {
            resetForm(_fromName) {
                this.$refs[_fromName].resetFields();
            },
            handleSelectionChange(val) {
                console.log(val)
                this.checkInputs = val;
            },
            dateRangeChangFun(e) {
                if (null == e) {
                    this.$set(this.query, 'startTime', null);
                    this.$set(this.query, 'endTime', null);
                } else {
                    this.$set(this.query, 'startTime', e[0]);
                    this.$set(this.query, 'endTime', e[1]);
                }

            },
            fillData(_response) {
                var _this = this;
                _this.cashItems = _response.items;
            },
            submitQuery(_num) {
                var _this = this;
                _this.cashItems = [];
                _this.query.vipRank = _this.query.level;
                _this.$refs.pager.gotoPage(_num);
            },
            checkAll() {
                var getAll = document.getElementsByName("all");
                var items = document.getElementsByName("item");
                for (var i = 0; i < items.length; i++) {
                    items[i].checked = getAll[0].checked;
                }
            },
            openCheckDialog(_id) {
                this.dialogVisible = true;
                this.disabledCash = false;
                this.checkModel.withdrawIds.push(_id);
            },
            exportWithdrawalsRecord() {
                var _this = this;
                _this.$confirm('确认执行该操作?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.$common.my_ajax({
                        url: 'withdrawalsRecord/exportWithdrawalsRecord',
                        data: _this.query,
                        success: function (response) {
                            var filePath = response.item;
                            // console.log(dynamicResourcePath+filePath);
                            window.location.href = _this.dynamicResourcePath + filePath;
                            _this.$message({
                                type: 'success',
                                message: '导出成功'
                            });
                        }
                    });
                }).catch(() => {
                    
                });
            },
            updateBalanceExtractStatus(_fromName) {
                var _this = this;
                _this.$refs[_fromName].validate((valid) => {
                    if (valid) {
                        _this.$confirm('确认执行该操作?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            _this.disabledCash = true;
                            _this.$common.my_ajax({
                                url: 'withdrawalsRecord/saveCheck',
                                data: _this.checkModel,
                                contentType: 'application/json',
                                success: function (response) {
                                    _this.$message({
                                        type: 'success',
                                        message: '操作成功'
                                    });
                                    _this.dialogVisible = false;
                                    _this.submitQuery(1);
                                }
                            });
                        }).catch(() => {
                            _this.$message({
                                type: 'info',
                                message: '已取消操作'
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            batchControlAuthentication(_status) {

                var _this = this;
                if (0 == _this.checkInputs.length) {
                    _this.$message({
                        type: 'error',
                        message: '请先选择数据',
                        duration: 1000,
                    });
                    return false;
                }
                var cashIdArray = [];
                for (var i = 0; i < _this.checkInputs.length; i++) {
                    var checkInput = _this.checkInputs[i];
                    cashIdArray.push(checkInput.id);
                }
                _this.$confirm('该操作将批量审核所选, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.$common
                        .my_ajax({
                            url: 'withdrawalsRecord/saveCheck',
                            data: {
                                withdrawIds: cashIdArray,
                                status: _status,
                            },
                            contentType: 'application/json',
                            success: function (response) {
                                _this.$message({
                                    type: 'success',
                                    message: '操作成功'
                                });
                                _this.submitQuery(1);
                            }
                        });
                }).catch(() => {
                    
                });
            },
        }
    }
</script>
<style scoped>
</style>